// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-full-disk-encryption.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-full-disk-encryption',
  title: 'Enforce full disk encryption and removable media DLP on endpoint devices',
  description:
    'Devices used to deliver government framework services must have full disk encryption enabled. The use of and connection to removable media must be monitored and logged. Copying of sensitive files must be restricted to approved removable media only. These controls together prevent data leakage in the event of device loss or theft.',
  category: 'technical',
  scfIds: ['SCF-DAT-002', 'SCF-AST-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Full disk encryption and removable media policy is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
